/* eslint-disable no-unused-expressions */
/* eslint-disable no-lone-blocks */
import { useAuth0 } from "@auth0/auth0-react";
import AuthService from "Lib/API/Auth";
import FinanceSettingService from "Lib/API/FinanceSetting/FinanceSetting";
import MembersSettingService from "Lib/API/MemberSetting/MemeberSetting";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import BackSvgComponent from "assets/icons/svg/back";
import DatePickers from "components/DatePicker/DatePicker";
import MultipleInput from "components/Multiple";
import MyButton from "components/MyButton";
import InfoTooltip from "components/InfoTooltip";
import SearchBar from "components/Search";
import { convertUTCToLocalDate } from "components/UTC/UtcConverter.js";
import { getDateFormat, getDateFormatForDatePicket, maskDate } from "helper/dateFormat.js";
import * as _ from "lodash";
import { isEmpty } from "lodash";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select";
import MaskedInput from "react-text-mask";
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import { DateFormetContext } from "../../../app/App.js";
import { collectionDisplayName, filterParameters } from "./filterSlice";
import "./index.scss";


const selectControlStyles = {
  backgroundColor: "#FFFFFF",
  border: "1px solid #ebedf3",
  color: "#030303",
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",
  fontSize: "14px",
};
const colourStyles = {
  control: (styles) => ({
    ...styles,
    ...selectControlStyles,
  }),
  menuList: (styles) => ({
    ...styles,
    maxHeight: "150px",
    fontSize: "14px",
    color: "#030303",
  }),
};
const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <BottomArrowSvg label="Emoji" />
    </components.DropdownIndicator>
  );
};

const ParameterValue = ({ onClick, id, getPreviousVal }) => {
  const dateFormet = React.useContext(DateFormetContext);
  const dispatch = useDispatch();
  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;

  const filterParamsInitial = useSelector(
    (state) => state?.filterParams?.fieldsGroup
  );
  const [preSavedData, setPreSavedData] = useState();
  const [filters, setFilters] = useState(filterParamsInitial || {});
  const [searchTerm, setValue] = useState("");
  const [parameter, setParameter] = useState([]);
  const [operator, setOperator] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = React.useState([]);
  const [accountTags, setAccountTags] = useState([]);
  const [accountTagsLoading, setAccountTagsLoading] = useState(false);
  const [contactTags, setContactTags] = useState([]);
  const [contactTagsLoading, setContactTagsLoading] = useState(false);
  const [selectedMultiValue, setSelectedMultiValue] = useState({});
  const [accountTypes, setAccountTypes] = useState([]);
  const [accountCategories, setAccountCategories] = useState([]);
  const [accountCategoriesLoading, setAccountCategoriesLoading] = useState(false);
  const [billingTypes, setBillingTypes] = useState([]);
  const [billingTypesLoading, setBillingTypesLoading] = useState(false);
  const [getFilterByIdLoading, setGetFilterByIdLoading] = useState(true);

  const dateMask = maskDate();
  const dateFormatPlaceholder = getDateFormat();
  const dateFormat = getDateFormatForDatePicket();

  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(dateFormat || "mm/dd/yyyy");


  const enableLoading = (value) => {
    setLoading(value);
  };
  const exceptThisSymbols = ["e", "E", "+", "-"];

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };
  const { getAccessTokenSilently } = useAuth0();
  const queryParams = new URLSearchParams(window.location.search);
  const filterId = queryParams.get("id");
  const [dateMap, setDateMap] = useState({});
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const pickerRefs = useRef({});
  const valuesContainerRef = useRef(null);


  const setApplyValues = (key, list) => {
    const selectedFilterData = Object.keys(filterParamsInitial)?.length ? filterParamsInitial : filters;
    const filterValue = typeof selectedFilterData?.[key]?.values === 'string' ? selectedFilterData?.[key]?.values?.split(" , "): Array.isArray(selectedFilterData?.[key]?.values?.[0]) ? selectedFilterData?.[key]?.values?.[0] : selectedFilterData?.[key]?.values;
    if (filterValue?.length > 0) {
      const filterSelectedValues = list?.filter((item) => {
        const found = filterValue?.find((value) => value === item?.key);
        if (found && found != undefined) {
          return item;
        }
      });
      filterSelectedValues?.length && setSelectedMultiValue((prev) => {
        return {
          ...prev,
          [key]: filterSelectedValues,
        };
      }
      )
    }
  }


  const getAccountTagsHandler = async () => {
    const token = await getAccessTokenSilently();
    setAccountTagsLoading(true);
    AuthService.getTags(
      'account',
      "",
      "",
      token
    )
      .then((res) => {
        const tags = res?.result;
        const filterTags = tags?.map((item) => {
          return {
            label: item?.title,
            key: item?.title,
            value: item?._id,
          };
        });
        setAccountTags(filterTags);
        setApplyValues("account.tags", filterTags)
      })
      .catch((err) => {
        console.log('err: ', err);
        toastr.error('Error', err?.data?.message || 'Something went wrong');
      }).finally(() => {
        setAccountTagsLoading(false);
      });
  };
  const getContactTagsHandler = async () => {
    const token = await getAccessTokenSilently();
    setContactTagsLoading(true);
    AuthService.getTags(
      'contact',
      "",
      "",
      token
    )
      .then((res) => {
        const tags = res?.result;
        const filterTags = tags?.map((item) => {
          return {
            label: item?.title,
            key: item?.title,
            value: item?._id,
          };
        });
        setContactTags(filterTags);
        setApplyValues("tags", filterTags)
      })
      .catch((err) => {
        console.log('err: ', err);
        toastr.error('Error', err?.data?.message || 'Something went wrong');
      }).finally(() => {
        setContactTagsLoading(false);
      });
  };
  const getAccountCategoriesHandler = async () => {
    setAccountCategoriesLoading(true);
    const token = await getAccessTokenSilently();
    MembersSettingService.getCatagoryListByType(
      "", token
    )
      .then((res) => {
        const accountCategories = res?.result;
        const filterAccountCategories = accountCategories?.map((item) => {
          return {
            label: item?.title,
            key: item?.title,
            value: item?._id,
          };
        });
        setAccountCategories(filterAccountCategories);
        setApplyValues("account.payment.account_sub_type.title", filterAccountCategories)
      })
      .catch((err) => {
        console.log('err: ', err);
        toastr.error('Error', err?.data?.message || 'Something went wrong');
      }).finally(() => {
        setAccountCategoriesLoading(false);
      });
  };

  const getBillingTypesHandler = async () => {
    setBillingTypesLoading(true);
    const token = await getAccessTokenSilently();
    FinanceSettingService.getAccountBillingTypes(token)
      .then((res) => {
        const billingTypes = res?.result;
        const filterBillingTypes = billingTypes?.map((item) => {
          return {
            label: item?.title,
            key: item?.title,
            value: item?._id,
          };
        });
        setBillingTypes(filterBillingTypes);
        setApplyValues("account.payment.billing_type.title", filterBillingTypes)

      })
      .catch((err) => {
        console.log('err: ', err);
        toastr.error('Error', err?.data?.message || 'Something went wrong');
      }).finally(() => {
        setBillingTypesLoading(false);
      });
  }

  const getAccountTypesHandler = async () => {
    const accountTypes = [
      {
        label: "Member",
        key: "member",
        value: "member"
      },
      {
        label: "Not a Member",
        key: "non-member",
        value: "non-member"
      },
      {
        label: "Organization",
        key: "organization",
        value: "organization"
      }
    ]
    setAccountTypes(accountTypes);
    setApplyValues("account.payment.account_type", accountTypes);
  };

  useEffect(() => {
    if (getFilterByIdLoading && id && getPreviousVal) return;
    getAccountTagsHandler();
    getContactTagsHandler();
    getAccountTypesHandler();
    getAccountCategoriesHandler();
    getBillingTypesHandler();
  }, [getFilterByIdLoading,getPreviousVal]);





  const getFilterById = async () => {
    if (id != null) {
      if (Object.keys(filterParamsInitial).length > 0) {
        setFilters(filterParamsInitial);
        setGetFilterByIdLoading(false);
        return;
      }
      setGetFilterByIdLoading(true);
      const token = await getAccessTokenSilently();
      await AuthService.getFilterById(id, token).then((res) => {
        let tempFilter = {};
        res?.selectedFields.map((ele) => {
          let tempStr = "";
          ele?.fieldName.split("_").forEach((ele) => {
            const str2 = ele.charAt(0).toUpperCase() + ele.slice(1);
            tempStr += " " + str2;
          });
          const values = ele?.fieldValue?.map(v => typeof v === 'string' ? v.trim() : v);
          const result = values?.join(' , ');

          tempFilter = {
            ...filters,
            ...tempFilter,
            [ele.fieldName]: {
              collectionName: ele?.collectionName,
              displayName: ele?.displayName,
              fieldName: ele?.fieldName,
              operator: ele?.operator,
              oprInputType: ele?.type,
              values: ele?.fieldValue?.length > 0 ?
                ele?.type === "bool" ? ele?.fieldValue :
                ele?.operator === 16 ? ele?.fieldValue.map(Number) :
                  result
                : ele?.fieldValue[0],
              form: "edit"
            },
          };
        });
        setFilters(tempFilter);
      }).catch((err) => {
        toastr.error("Error", err?.data?.message);
      }).finally(() => {
        setGetFilterByIdLoading(false);
      });
    }
  };
  React.useEffect(() => {
    if (getPreviousVal) {
      getFilterById();
    }
  }, [id]);
  React.useEffect(() => {
    let parameterDataFromApi = [];
    let operatorDataFromApi = [];
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      await AuthService.getFilterParams(token)
        .then((res) => {
          enableLoading(true);
          if (res.length) {
            parameterDataFromApi = res;
            setParameter(res);
          }
          enableLoading(false);
        })
        .catch((err) => {
          enableLoading(false);
          toastr.error("Error", err?.data?.message);
        });

      await AuthService.getOperatorParams(token)
        .then((res) => {
          enableLoading(true);
          if (res.length) {
            operatorDataFromApi = res;
            setOperator(res);
          }
          enableLoading(false);
        })
        .catch((err) => {
          enableLoading(false);
          toastr.error("Error", err?.data?.message);
        });

      {
        filterId && !Object.keys(filterParamsInitial).length
          ? AuthService.getFilterById(filterId, token)
            .then((res) => {
              setPreSavedData(res);
              let newData = filterParamsInitial || {};
              const updatedData = res.selectedFields.map(
                ({ fieldName, collectionName, fieldValue, operator, type }) => {
                  const foundData = _.find(
                    parameterDataFromApi,
                    (item) => item.collectionName === collectionName
                  );
                  if (foundData) {
                    const foundFieldsGroup = _.find(
                      foundData.fieldsGroup,
                      (item) => item.fieldName === fieldName
                    );
                    if (foundFieldsGroup) {
                      const foundOperator = _.find(
                        operatorDataFromApi,
                        (item) => item.oprId === operator
                      );
                      newData = {
                        ...newData,
                        [fieldName]: {
                          operator: operator,
                          oprInputType: foundOperator?.oprInputType || 0, //need to chnage
                          values: operator === 16 ? fieldValue.map(Number) : Array.isArray(fieldValue[0]) ? fieldValue[0].map(v => typeof v === 'string' ? v.trim() : v) : fieldValue[0],
                          fieldName,
                          displayName: foundFieldsGroup?.displayName,
                          collectionName: collectionName,
                          type: type
                        },
                      };
                    }
                  }
                }
              );
              setFilters(newData);
            })
            .catch((err) => { })
          : {};
      }
    }
    fetchMyAPI();
  }, [filterId, filterParamsInitial, getAccessTokenSilently]);
  /**
   * Adds value to filter by given key
   * @param {any} value
   */
  const addFilter = (filterName, item) => {
    const { fieldName, displayName, type } = filterName;
    setFilters({
      ...filters,
      [fieldName]: {
        operator: null,
        oprInputType: type ?? operator[0].oprInputType,
        values: null,
        fieldName,
        displayName,
        collectionName: item?.collectionName,
      },
    });
  };

  /**
   * Remove object value from given
   * @param {any} value, object key
   */
  const removeFilter = (value) => {
    let newFilters = {};
    const filtered = Object.keys(filters).filter((key) => key !== value);
    filtered.forEach((key) => {
      newFilters[key] = filters[key];
    });
    setFilters(newFilters);
  };

  /**
   * Handles the click evnet of the tag
   * @param {any} filterName, Name of the filter
   */
  const handleClick = async (filterName, item) => {
    /**
     * Add the filter if not exist else remove it from object
     */
    addFilter(filterName, item);
    await dispatch(collectionDisplayName(item?.collectionName));
  };
  useEffect(() => { }, [filters]);

  const setOperatorToFilter = (operatorId, filterName, type) => {
    setFilters((filt) => {
      return {
        ...filt,
        [filterName]: {
          ...filt[filterName],
          operator: operatorId,
          values: null,
          form: 'add',
          oprInputType: type ?? operator.find((o) => o.oprId == operatorId)
            .oprInputType,
        },
      };
    });
  };

  function convertLocalToUTCDate(name, date) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    handleOperaterValueChange(name, date);
    // formik.setFieldValue(name, date);
    return date;
  }

  const handleOperaterValueChange = (filterName, value) => {
    setFilters((filt) => {
      return {
        ...filt,
        [filterName]: {
          ...filt[filterName],
          values: [value],
        },
      };
    });
  };

  const handleRangeValueChange = (filterName, index, value) => {
    setFilters((filt) => {
      const current = Array.isArray(filt[filterName]?.values) ? [...filt[filterName].values] : [null, null];
      current[index] = value === "" ? null : Number(value);
      return {
        ...filt,
        [filterName]: {
          ...filt[filterName],
          values: current,
        },
      };
    });
  };



  const multiSelectOptions = {
    "account.tags": accountTags,
    "tags": contactTags,
    "account.payment.account_type": accountTypes,
    "account.payment.account_sub_type.title": accountCategories,
    "account.payment.billing_type.title": billingTypes,
  }

  const multiSelectOptionsLoading = {
    "account.tags": accountTagsLoading,
    "tags": contactTagsLoading,
    "account.payment.account_type": false,
    "account.payment.account_sub_type.title": accountCategoriesLoading,
    "account.payment.billing_type.title": billingTypesLoading,
  }

  const dateRangeValue = (date) => {
    if (!date) return [];
    const dateRange = typeof date === "string" ? date?.split(",") : date;
    const startDate = moment(dateRange[0]).toDate();
    const endDate = moment(dateRange[1]).toDate();
    return [startDate, endDate];
  }



  const getBooleanValue = (value) => {
    if (value == undefined) return "";
    if (typeof value === "array") return value?.[0] == "true" ? "1" : "0";
    return value == "true" ? "1" : "0";
  }

  const getPlaceholder = (filterKey) => {
    const displayName = filters[filterKey]?.displayName || filterKey;
    return `Enter ${displayName}`;
  };

  const handleCsvImport = (filterKey, e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    e.target.value = "";
    const reader = new FileReader();
    reader.onload = (event) => {
      const text = event.target.result;
      const lines = text.split(/\r?\n/).filter(l => l.trim()).slice(1);
      const values = lines.map(line => {
        const cols = line.split(",");
        return cols[0].replace(/^["']|["']$/g, "").trim();
      }).filter(v => v);
      setFilters((prev) => {
        const existing = Array.isArray(prev[filterKey]?.values?.[0]) ? prev[filterKey].values[0] : [];
        const merged = [...new Set([...existing, ...values])].slice(0, 500);
        if (merged.length === 500) {
          toastr.info("Limit reached", "Only 500 entries are allowed in the list. Extra values were ignored.");
        }
        setTags(merged);
        return {
          ...prev,
          [filterKey]: {
            ...prev[filterKey],
            values: [merged],
          },
        };
      });
    };
    reader.readAsText(file);
  };

  const csvHintTitle = "CSV Import: The first row is treated as a header and will be skipped. If your file has a single column, each remaining row will be added as a value. If it has multiple columns, only the first column will be used. Imported values are merged with any existing entries.";

  const getOprInputValue = (filterKey) => {
    const selectOp = filters[filterKey].oprInputType;
    switch (selectOp) {
      case "text":
        if (filters[filterKey].operator === 7 || filters[filterKey].operator === 8) {
          return (
            <div className="params-values">
              <div className="multi-input-value">
                <MultipleInput
                  prevTags={filters[filterKey].values}
                  setFilters={setFilters}
                  filters={filters}
                  keyData={filterKey}
                  setTags={setTags}
                  tags={tags}
                />
              </div>
            </div>
          );
        }
        else {
          return (
            <div className="params-values">
              <input
                type="text"
                className="input-value"
                onChange={(e) =>
                  handleOperaterValueChange(filterKey, e.target.value)
                }
                value={filters[filterKey].values || ""}
                required={filters[filterKey].values !== ""}
                maxLength={150}
                placeholder={getPlaceholder(filterKey)}
              />
            </div>
          );
        }
      case "number":
        if (filters[filterKey].operator === 7 || filters[filterKey].operator === 8) {
          return (
            <div className="params-values">
              <div className="multi-input-value">
                <MultipleInput
                  prevTags={filters[filterKey].values}
                  setFilters={setFilters}
                  filters={filters}
                  keyData={filterKey}
                  setTags={setTags}
                  tags={tags}

                />
              </div>
            </div>
          );
        }
        if (filters[filterKey].operator === 16) {
          const rangeVals = Array.isArray(filters[filterKey]?.values) ? filters[filterKey].values : [null, null];
          return (
            <div className="params-values">
              <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "100%" }}>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  onKeyDown={(e) => preventArrows(e)}
                  className="input-value"
                  style={{ flex: 1, marginTop: "10px" }}
                  placeholder="Min"
                  maxLength={10}
                  value={rangeVals[0] ?? ""}
                  onChange={(e) => { if (e.target.value.length <= 10) handleRangeValueChange(filterKey, 0, e.target.value); }}
                />
                <span style={{ color: "#b5b5c3", fontWeight: 500, marginTop: "10px" }}>–</span>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  onKeyDown={(e) => preventArrows(e)}
                  className="input-value"
                  style={{ flex: 1, marginTop: "10px" }}
                  placeholder="Max"
                  maxLength={10}
                  value={rangeVals[1] ?? ""}
                  onChange={(e) => { if (e.target.value.length <= 10) handleRangeValueChange(filterKey, 1, e.target.value); }}
                />
              </div>
            </div>
          );
        }
        return (
          <div className="params-values">
            <input
              type="number"
              onWheel={(e) => e.target.blur()}
              onKeyDown={(e) => preventArrows(e)}
              className="input-value"
              required={filters[filterKey].values !== ""}
              value={filters[filterKey].values || ""}
              onChange={(e) =>
                handleOperaterValueChange(
                  filterKey,
                  e.target.value
                  // e.target.value.match(regex)[0]
                )
              }
            />
          </div>
        );
      case "multiplechoice":
        return (
          <div className="params-values">
            <div className="multi-input-value">
              <MultipleInput
                prevTags={filters[filterKey].values}
                setFilters={setFilters}
                filters={filters}
                keyData={filterKey}
                setTags={setTags}
                tags={tags}
              />
            </div>
          </div>
        );
      case "list":
        return (
          <div className="params-values">
            <div className="multi-input-value">
              <MultipleInput
                prevTags={filters[filterKey].values}
                setFilters={setFilters}
                filters={filters}
                keyData={filterKey}
                setTags={setTags}
                tags={tags}
              />
            </div>
          </div>
        );
      case "date":
        if (filters[filterKey].operator === 10) {
          return (
            <div className="params-values">
              <DateRangePicker
                format={dateFormat}
                placeholder={`${dateFormatPlaceholder}  ~  ${dateFormatPlaceholder}`}
                cleanable={true}
                placement="bottomEnd"
                ref={el => { pickerRefs.current[`date-${filterKey}`] = el; }}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                style={
                  {
                    display: "inline-block",
                    padding: '0',
                    border: '0',
                    width: "100%",
                    color: 'black',
                    marginTop: "10px",
                  }
                }
                size="lg"
                value={dateMap[filterKey]?.length ? dateMap[filterKey] : dateRangeValue(filters[filterKey].values)}
                onChange={(update) => {
                  const [startDate, endDate] = update;
                  let data = filters;
                  data[filterKey].values = [
                    moment(startDate).format(dateFormet),
                    moment(endDate).format(dateFormet),
                  ];
                  setFilters(data);
                  setDateMap(prev => ({ ...prev, [filterKey]: update }));
                }} />
            </div>
          );
        }
        else
          return (
            <div className="params-values">
              <div className="form-group">
                {/* {filters[filterKey].form === "edit" ? <input
                type="text"
                className="input-value"
                onChange={(e) =>
                  handleOperaterValueChange(filterKey, e.target.value)
                }
                value={moment(filters[filterKey].values).format("MM/DD/YYYY") || ""}
                required={filters[filterKey].values !== ""}
              /> :  */}
                <DatePicker
                  // isClearable
                  placeholderText={dateFormatPlaceholder}
                  dateFormat={dateFormat}
                  selected={
                    (typeof filters?.[filterKey]?.values === 'string') ? convertUTCToLocalDate(filters[filterKey].values) : Array.isArray(filters?.[filterKey]?.values) &&
                    convertUTCToLocalDate(filters[filterKey]?.values?.[0])
                  }
                  onChange={(e) => {
                    convertLocalToUTCDate(filterKey, e);
                    // handleOperaterValueChange(filterKey, e);
                  }}
                  customInput={
                    <MaskedInput
                      pipe={autoCorrectedDatePipe}
                      mask={dateMask}
                      keepCharPositions={true}
                      guide={true}
                    />
                  }
                />
                {/* } */}
              </div>
            </div>
          );
      case "daterange":
        return (
          <div className="params-values">
            <DateRangePicker format={dateFormat}
              placeholder={`${dateFormatPlaceholder}  ~  ${dateFormatPlaceholder}`}
              cleanable={true}
              placement="bottomEnd"
              ref={el => { pickerRefs.current[`daterange-${filterKey}`] = el; }}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              style={
                {
                  display: "inline-block",
                  padding: '0',
                  border: '0',
                  width: "100%",
                  color: 'black',
                  marginTop: "10px",
                }
              }
              size="lg"
              value={dateMap[filterKey] || null}
              onChange={(update) => {
                const [startDate, endDate] = update;
                let data = filters;
                data[filterKey].values = [
                  moment(startDate).utcOffset("+0100").format(dateFormet),
                  moment(endDate).utcOffset("+0100").format(dateFormet),
                ];
                setFilters(data);
                setDateMap(prev => ({ ...prev, [filterKey]: update }));
              }} />
            {/* <DatePicker
              selectsRange={true}
              startDate={startDate}
              endDate={endDate}
              className={"date-range-container input-value"}
              onChange={(update) => {
                const [startDate, endDate] = update;
                let data = filters;
                data[filterKey].values = [
                  moment(startDate).utcOffset("+0100").format(dateFormet),
                  moment(endDate).utcOffset("+0100").format(dateFormet),
                ];
                setFilters(data);
                setDateRange(update);
              }}
            // isClearable={true}
            /> */}
          </div>
        );
      case "textlike":
        return (
          <div className="params-values">
            <input
              className="input-value"
              value={filters[filterKey].values || ""}
              onChange={(e) =>
                handleOperaterValueChange(filterKey, e.target.value)
              }
              maxLength={150}
              placeholder={getPlaceholder(filterKey)}
            />
          </div>
        );
        
        case "multiSelect":
        return (
          <div className="params-values mt-2">
            <Select
              classNamePrefix="react-select"
              options={multiSelectOptions[filterKey]}
              isMulti
              isLoading={multiSelectOptionsLoading[filterKey]}
              styles={colourStyles}
              onChange={(items) => {
                if (filters[filterKey]) {
                  handleOperaterValueChange(filterKey, items.map((item) => item.key))
                }
                setSelectedMultiValue((prev) => {
                  return {
                    ...prev,
                    [filterKey]: items,
                  };
                }
                )
              }}
              value={selectedMultiValue[filterKey]}
              components={{ DropdownIndicator }}
            />
          </div>

        );
      default:
        return "";
      case "bool":
        return (
          <div className="params-values mt-2">
            <select
              name="operators"
              className="params-values-selection"
              onChange={(e) => {
                handleOperaterValueChange(filterKey, e.target.value === "1" ? true : false)
              }}
              value={getBooleanValue(filters[filterKey]?.values)}
            >
              <option value="" disabled selected hidden>Select option</option>
              <option value={"1"}>
                Yes
              </option >
              <option value={"0"}>
                No
              </option>
            </select>
          </div>
        );
    }
  };

  const validationHandler = (filters) => {
    for (const key in filters) {
      const { operator, values } = filters[key] || {};
      
      if (operator === 12 || operator === 13) return false;
      if (!operator || !values || !values?.length || (Array.isArray(values) && !values?.[0])  || (Array.isArray(values?.[0]) && !values?.[0]?.length)) {
        toastr.info("validation", "Please fill all the fields");
        return true;
      }
    }
    return false;
  };
  

  async function sendData() {
    if (validationHandler(filters)) return;
    await dispatch(filterParameters(filters));
    onClick();
  }

  const handleNextDisabled = () => {
    const result = Object.keys(filters).map((filterKey, index) => {
      if (
        filters?.[filterKey]?.operator &&
        filters?.[filterKey]?.values &&
        filters?.[filterKey]?.values[0] !== "" &&
        filters?.[filterKey]?.values.length > 0 &&
        !isEmpty(filters?.[filterKey]?.values[0]) &&
        filters?.[filterKey]?.values[0] !== "Invalid date" &&
        filters?.[filterKey]?.values[1] !== "Invalid date"
      ) {
        return false;
      } else {
        return false;
      }
    });

    return result.some((v) => v === true);
  };
  useEffect(() => {
    handleNextDisabled();
  }, [filters, tags]);

  useEffect(() => {
    const container = valuesContainerRef.current;
    if (!container) return;
    const handleScroll = () => {
      Object.values(pickerRefs.current).forEach(picker => picker?.close?.());
    };
    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="parameter-values">
      <div className="heading">Choose a Filter</div>
      <div className="details">
        <div className="parameter">
          <div className="parameter-form">
            <div className="parameter-head d-flex align-items-center">
              PARAMETERS
              <InfoTooltip text="Click a field here to add a filter condition on it. Fields already added are hidden from this list." placement="bottom" useFixed style={{ marginLeft: '6px' }} />
            </div>
            <div className="filter-search-bar pb-2 pt-2">
              <SearchBar searchTerm={searchTerm} setValue={setValue} />
            </div>
            <div>
              {parameter?.map((item, index) => {
                return (
                  <div className="member-search" key={index}>
                    <div className="member-head">{item?.collectionName?.toLowerCase() === "members" ? "Members" : item?.collectionName}</div>
                    <div className="search-items">
                      {item?.fieldsGroup
                        .filter(
                          (value) =>
                            value.displayName
                              .toLowerCase()
                              .includes(searchTerm.toLowerCase()) &&
                            !_.find(
                              filters,
                              (item) => item.displayName === value.displayName
                            )
                        )
                        .map((data, index) => {
                          return (
                            <div
                              key={index}
                              className={`search-options ${data.fieldName in filters ? "active" : ""
                                }`}
                              onClick={() => handleClick(data, item)}
                            >
                              {data?.displayName}
                            </div>
                          );
                        })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="vallues">
          <div className="parameter-form" ref={valuesContainerRef}>
            <div className="parameter-head d-flex align-items-center">
              VALUES
              <InfoTooltip text="For each field you picked, choose an operator (e.g. equals, contains, greater than) and the value(s) to match against." placement="bottom" useFixed style={{ marginLeft: '6px' }} />
            </div>
            {!Object.keys(filters).length ? (
              <div className="choose-parameter-text">
                <span>Please choose from the</span>
                <span>Parameters in the left box</span>
              </div>
            ) : (
              Object.keys(filters).map((filterKey, index) => (
                <div className="parameter-value" key={index}>
                  <div className="value-options">
                    <div className="search-value-fielt">Field Name:</div>
                    <div className="search-value-operator">Operator:</div>
                    {(filters[filterKey]?.operator !== 12 && filters[filterKey]?.operator !== 13) && (
                      <div
                        className="search-value-input"
                        style={(filters[filterKey]?.operator === 7 || filters[filterKey]?.operator === 8) ? { marginTop: "75px" } : {}}
                      >Values:</div>
                    )}
                  </div>
                  <div className="field-params-values">
                    <div className="params-field-name">
                      {filters[filterKey].displayName}
                    </div>
                    <div className="params-operator">
                      {/* <select name="operators" className="search-operator" onChange={(e) => setSelectOp(filters?.oprDisplay)}> */}
                      <select
                        name="operators"
                        className="search-operator"
                        onChange={(e) => {
                          setOperatorToFilter(
                            Number(e.target.value),
                            filterKey,
                            filters[filterKey].oprInputType
                          );
                          if (filterKey === "account.tags" || filterKey === "tags") {
                            setSelectedMultiValue((prev) => {
                              return {
                                ...prev,
                                [filterKey]: [],
                              };
                            }
                            )
                          }
                        }}
                        value={filters[filterKey].operator}
                      >
                        <option selected="true" disabled="disabled">
                          Select option
                        </option>

                        {operator.map((item, index) => (
                          <>
                            {
                              item?.types.includes(filters[filterKey].oprInputType) &&
                              <option value={item.oprId} key={index}>
                                {item.oprDisplay?.charAt(0).toUpperCase() + item.oprDisplay?.slice(1)}
                              </option>
                            }
                          </>

                        ))}
                      </select>
                    </div>
                    {(filters[filterKey]?.operator === 7 || filters[filterKey]?.operator === 8) && (
                      <div style={{ display: "flex", gap: "6px", marginTop: "14px", width: "100%" }}>
                        <label
                          htmlFor={`csv-import-${filterKey}`}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "5px",
                            fontSize: "12px",
                            color: "#2555ef",
                            cursor: "pointer",
                            fontWeight: 500,
                            border: "1px solid #2555ef",
                            borderRadius: "4px",
                            padding: "3px 10px",
                            lineHeight: 1.5,
                            height: "28px",
                            boxSizing: "border-box",
                          }}
                        >
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
                          </svg>
                          Import via CSV
                        </label>
                        <div style={{ width: "28px", height: "28px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <InfoTooltip text={csvHintTitle} placement="top" />
                        </div>
                        <input
                          id={`csv-import-${filterKey}`}
                          type="file"
                          accept=".csv"
                          style={{ display: "none" }}
                          onChange={(e) => handleCsvImport(filterKey, e)}
                        />
                      </div>
                    )}
                    {(filters[filterKey]?.operator !== 12 && filters[filterKey]?.operator !== 13) && (
                      <div className="params-values">
                        {getOprInputValue(filterKey)}
                      </div>
                    )}
                  </div>
                  <div className="back-button">
                    <BackSvgComponent onClick={() => removeFilter(filterKey)} />
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
      <hr />
      <div className="next-button">
        <MyButton
          content="Next"
          style={{ width: "100px", height: "40px", marginBottom: "25px" }}
          onClick={sendData}
          disabled={
            handleNextDisabled() || !Object.keys(filters).length ? true : false
          }
        />
      </div>
    </div>
  );
};

export default ParameterValue;
